export const cvData = {
  name: "Jakob B. Bronebakk",
  title: "CFA",
  contact: {
    address: "Tanumveien 109A, 1341 Slependen",
    country: { no: "Norge", en: "Norway" },
    phone: "+47 906 39 637",
    email: "bronebakk@hey.com",
    linkedin: "https://www.linkedin.com/in/bronebakk/"
  },
  summary: {
    no: "Strategisk finansleder, CFA og MBA med en unik kombinasjon av CxO-erfaring, praktisk AI-implementering og dyp teknisk kompetanse innen Data & Analyse, AI/ML og Finansmarkeder. Dokumentert evne til å bygge bro mellom forretning og teknologi – like hjemme i styrerommet som i teknisk implementering. Har personlig bygget datavarehus, ledet GenAI-initiativer og rullet ut AI-drevne produkter i produksjon.",
    en: "Strategic Finance Executive, CFA and MBA with a distinctive combination of CxO-level leadership, hands-on AI implementation experience, and deep technical expertise in Data & Analytics, AI/ML, and Financial Markets. Proven ability to bridge the gap between business and technology — fluent in both boardroom strategy and technical implementation. Track record of personally building data warehouses, leading GenAI initiatives, and deploying AI-powered products in production."
  },
  competencies: [
    {
      title: { no: "AI & Dataimplementering", en: "AI & Data Implementation" },
      description: {
        no: "Initierte Kredinors GenAI-pilot som hovedpådriver på CxO-nivå. Ledet utvikling av produksjonsklare RAG-baserte multi-LLM-systemer. Personlig bygget datavarehus i flere organisasjoner. Formell AI/ML-utdanning kombinert med praktisk erfaring.",
        en: "Initiated Kredinor's GenAI pilot as primary CxO advocate. Led development of production RAG-based multi-LLM systems. Personally built data warehouses from scratch at multiple organizations. Formal AI/ML education combined with hands-on development."
      },
      icon: "Brain"
    },
    {
      title: { no: "Bro mellom teknologi og forretning", en: "Technology-Business Bridge" },
      description: {
        no: "Oversetter komplekse tekniske konsepter for ledelse og styrer. Definerer forretningskrav for utviklingsteam. Evaluerer kjøp-vs-bygg med finansiell og teknisk tyngde.",
        en: "Translate complex technical concepts for executives and boards. Define business requirements for engineering teams. Evaluate build-vs-buy with financial and technical rigor."
      },
      icon: "TrendingUp"
    },
    {
      title: { no: "Økonomi og finansmarkeder", en: "Finance & Capital Markets" },
      description: {
        no: "Sikret 4,2 mrd NOK i finansiering og plasserte 1 mrd NOK obligasjon. Ledet ERP-implementeringer og automatisert arbeidsflytdesign. Dyp erfaring med SaaS-KPIer (churn, CAC, LTV), både oppsett, analyse og styring etter disse.",
        en: "Secured 4.2B NOK financing and placed 1B NOK bond. Led ERP implementations and automated workflow design. Deep SaaS metrics experience (churn, CAC, LTV) from both an analytical, operational and management perspective."
      },
      icon: "Briefcase"
    }
  ],
  experience: [
    {
      role: { no: "Daglig leder", en: "Chief Executive Officer" },
      company: "Naardic AS",
      location: "Oslo",
      dates: { no: "2024 – d.d.", en: "2024 – Present" },
      description: {
        no: "B2C fitness SaaS-startup. Ledet utvikling av \"Anne Iversen\" virtuell PT — et RAG-basert AI-system med flere LLM-er for personlig coaching i stor skala. Overtok som CEO i forbindelse med refinansiering av selskapet. Bygget automatisert rapporteringsinfrastruktur og effektivisert virksomheten med fokus på enhetsøkonomi.",
        en: "B2C fitness SaaS startup. Led development of \"Anne Iversen\" virtual PT — a RAG-based AI system using multiple LLMs for personalized coaching at scale. Built automated reporting infrastructure and driving Series-A preparation with focus on unit economics."
      }
    },
    {
      role: { no: "Styreleder", en: "Chairman of the Board" },
      company: "Digtective AS",
      location: "Oslo",
      dates: { no: "2024 – d.d.", en: "2024 – Present" },
      description: {
        no: "Konverteringssporing for digital markedsføring. Aktiv styrerolle med praktisk bidrag til GTM-strategi, produktutvikling og automatiserte analyseløsninger.",
        en: "Conversion tracking for digital marketing startup. Active governance role with hands-on contribution to GTM strategy, product development, and automated analysis capabilities."
      }
    },
    {
      role: { no: "Finansdirektør (CFO)", en: "Chief Financial Officer" },
      company: "Kredinor AS",
      location: "Oslo",
      dates: "2022 – 2024",
      description: {
        no: "Norges største inkassoselskap. Initierte selskapets GenAI-pilot som pådriver på ledernivå — først ute i norsk inkassobransje. Ledet ERP-implementering og finanstransformasjon. Sikret 4,2 mrd NOK i finansiering og plasserte 1 mrd NOK obligasjon.",
        en: "Norway's largest debt collection company. Initiated and championed the company's GenAI pilot as primary executive advocate — first mover in Norwegian debt collection. Led ERP implementation and finance transformation. Secured 4.2B NOK financing and placed 1B NOK bond."
      }
    },
    {
      role: { no: "Gründer & Tech Lead", en: "Founder & Tech Lead" },
      company: "Cerebell.ai",
      location: "Oslo",
      dates: "2021 – 2022",
      description: {
        no: "Grunnla \"Banking AI as a Service\" FinTech. Bygget AI/ML-prototyper for automatiserte banktjenester. Sikret finansiering fra Innovasjon Norge.",
        en: "Founded \"Banking AI as a Service\" FinTech. Built AI/ML prototypes for automated banking services. Secured Innovation Norway funding."
      }
    },
    {
      role: { no: "Daglig leder", en: "Chief Executive Officer" },
      company: "MyBank ASA",
      location: "Oslo",
      dates: "2019 – 2021",
      description: {
        no: "Gjennomførte komplett snuoperasjon fra underskudd til lønnsomhet gjennom datadrevet porteføljerestrukturering og teknologimodernisering.",
        en: "Executed complete turnaround from losses to profitability through data-driven portfolio restructuring and technology modernization."
      }
    },
    {
      role: { no: "Finansdirektør (CFO)", en: "Chief Financial Officer" },
      company: "MyBank ASA",
      location: "Oslo",
      dates: "2017 – 2019",
      description: {
        no: "Medgründer av banken. Personlig designet og bygget datavarehuset fra bunnen. Bidro til automatisert søknadssystem som reduserte manuell behandling med 80%+.",
        en: "Co-founded the bank. Personally designed and built the data warehouse from scratch. Helped build automated application system reducing manual processing by 80%+."
      }
    },
    {
      role: { no: "Managing Consultant", en: "Managing Consultant" },
      company: "Capgemini Consulting",
      location: "Oslo",
      dates: "2015 – 2016",
      description: {
        no: "Betalings- og FinTech-praksis. Nøkkelrolle i Nets-transformasjon etter PE-oppkjøp. Ledet Ethereum-pilot og fungerte som global blockchain-ekspert.",
        en: "Payments and FinTech practice. Key role in Nets transformation post-PE acquisition. Led Ethereum pilot and served as global blockchain SME."
      }
    },
    {
      role: "CFO",
      company: "Jernbanepersonalets Bank og Forsikring",
      location: "Oslo",
      dates: "2014 – 2015",
      description: {
        no: "Restrukturerte 2 mrd NOK investeringsportefølje og moderniserte salgsorganisasjonen.",
        en: "Restructured 2B NOK investment portfolio and modernized sales organization."
      }
    },
    {
      role: { no: "Risikosjef", en: "Risk Manager" },
      company: "Jernbanepersonalets Bank og Forsikring",
      location: "Oslo",
      dates: "2013 – 2014",
      description: {
        no: "Initierte datavarehusprosjekt som reduserte rapporteringstid med 80-90%. Implementerte COSO-ERM rammeverk.",
        en: "Initiated data warehouse project reducing reporting time by 80-90%. Implemented COSO-ERM frameworks."
      }
    },
    {
      role: "Partner",
      company: "Jubilee Financial Products LLP",
      location: "London",
      dates: "2008 – 2012",
      description: {
        no: "Medgründer av investeringsselskap. Strukturerte retailprodukter og forvaltet algoritmiske handelsfond.",
        en: "Co-founded investment firm. Structured retail products and managed algorithmic trading funds."
      }
    },
    {
      role: { no: "Derivatspesialist", en: "Derivatives Specialist" },
      company: "Lehman Brothers",
      location: "London",
      dates: "2003 – 2008",
      description: {
        no: "Spesialist på eksotiske derivater og megler for nordiske institusjonelle kunder.",
        en: "Exotic derivatives specialist and broker for Nordic institutional clients."
      }
    },
    {
      role: "Graduate Trainee",
      company: "UBS Warburg",
      location: "London",
      dates: "2001 – 2003",
      description: {
        no: "Tatt inn på globalt traineeprogram fra en stilling i linjen. Analyse og meglerstøtte på aksje- og derivathandel.",
        en: "Accepted onto graduate trainee programme from an operations line position. Operational analysis and trade support for equity and derivative trading."
      }
    }
  ],
  education: [
    {
      degree: { no: "Intelligente Systemer (AI/ML)", en: "Intelligent Systems (AI/ML)" },
      institution: { no: "Høyskolen Kristiania", en: "Kristiania University College" },
      dates: "2021 – 2022"
    },
    {
      degree: "Executive MBA",
      institution: { no: "NHH Norges Handelshøyskole", en: "NHH Norwegian School of Economics" },
      dates: "2015 – 2016"
    },
    {
      degree: "CFA",
      institution: "CFA Institute",
      dates: "2012"
    },
    {
      degree: "PGCert Finance",
      institution: "Birkbeck, University of London",
      dates: "2006"
    },
    {
      degree: "BSc International Relations",
      institution: "LSE",
      dates: "2000"
    }
  ],
  skills: {
    categories: [
      {
        title: "AI/ML",
        items: ["Python", "Prompt Engineering", { no: "AI-agenter", en: "AI Agents" }, { no: "LLM-integrasjon", en: "LLM Integration" }, "RAG"]
      },
      {
        title: "Data",
        items: ["SQL", { no: "Datavarehusdesign", en: "Data Warehouse Design" }, "ETL", "Power BI", { no: "Excel-modellering", en: "Excel Modeling" }]
      },
      {
        title: "Domain",
        items: [{ no: "Betalinger", en: "Payments" }, "SaaS-KPIer", "Blockchain", { no: "ERP-systemer", en: "ERP Systems" }]
      }
    ]
  },
  projects: [
    {
      name: "Ketchup",
      description: {
        no: "Lese-app for barn med høyt skolefravær.",
        en: "Reading app for children with high school absence."
      },
      url: "https://ketchup.ktrl.no",
      tag: "H2 2026 beta"
    }
  ],
  pdfUrls: {
    no: "/static/Jakob_Bronebakk_CV_NO.pdf",
    en: "/static/Jakob_Bronebakk_CV_ENG.pdf"
  }
};
